import React from 'react';

export default function FooterComponent() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer bg-dark text-light py-3 mt-4">
      <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center">
        <small className="mb-2 mb-md-0">© {year} Rebirth DnD. All rights reserved.</small>
        <nav>
          <a href="/about" className="text-light me-3">About</a>
        </nav>
      </div>
    </footer>
  );
}